<template>
    <div class="page-layout blank mb-10" style="min-height: 600px;overflow: auto;">
        <div class="vendor-list" id="printId">
            <div class="p-4">
                <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                    <div style="font-size: 15px;">
                        <span class="fw-500" style="text-transform:capitalize;"> Archived Tickets </span>  |  {{total}}  Total
                    </div>
                    <div class="d-flex align-items-center mt-1">
                        <!-- <button class="pointer exportButton pl-2 d-flex align-items-center btn-smm">
                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/export-new.svg" class="w-18">
                            <span class="text-white ml-1 hidden-sm-down fs-13">Export</span>
                        </button>
                        <button class="pointer pdfButton pl-2 d-flex align-items-center btn-smm ml-2">
                            <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/picture_pdf.svg" class="w-18">
                            <span class="text-white ml-1 hidden-sm-down fs-13">Pdf</span>
                        </button>
                        <button class="pointer printButton pl-2 d-flex align-items-center btn-smm ml-2">
                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/printer.svg" class="w-18">
                            <span class="text-white ml-1 hidden-sm-down fs-13">Print</span>
                        </button> -->
                        <button class="btn btn-secondary btn-smm ml-2" @click="showFilters()">
                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/filter.svg" class="mb-1">
                            <span class="text-white ml-1 hidden-sm-down fs-13">Filter</span>
                        </button>
                    </div>
                </div>
                <div class="table-content mb-3" style="overflow-y: auto;">
                    <table class="table table-content-data table-responsive">
                        <thead>
                            <tr>
                                <th class="whiteSpace w-1">
                                    <span v-on:click="setPasskey('ticket_number')" class="cursor-th" >
                                        Ticket ID
                                        <span v-if="passed_key.key=='ticket_number' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'ticket_number'}" class="sorting-icon">
                                            <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                        </span>
                                        <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'ticket_number'}" class="sorting-icon">
                                            <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                        </span>
                                    </span>
                                </th>
                                <th class="whiteSpace w-1">
                                    <span v-on:click="setPasskey('status')" class="cursor-th pl-4" >
                                        Status
                                        <span v-if="passed_key.key=='status' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'status'}" class="sorting-icon">
                                            <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                        </span>
                                        <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'status'}" class="sorting-icon">
                                            <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                        </span>
                                    </span>
                                </th>
                                <th class="whiteSpace w-1">
                                    <span v-on:click="setPasskey('author_name')" class="cursor-th" >
                                        Author Name
                                        <!-- <span v-if="passed_key.key=='author_name' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'author_name'}" class="sorting-icon">
                                            <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                        </span>
                                        <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'author_name'}" class="sorting-icon">
                                            <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                        </span> -->
                                    </span>
                                </th>
                                <th class="whiteSpace w-1">
                                    <span v-on:click="setPasskey('subject')" class="cursor-th" >
                                        Subject
                                        <span v-if="passed_key.key=='subject' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'subject'}" class="sorting-icon">
                                            <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                        </span>
                                        <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'subject'}" class="sorting-icon">
                                            <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                        </span>
                                    </span>
                                </th>
                                <th class="whiteSpace w-1">
                                    <span v-on:click="setPasskey('created_date')" class="cursor-th" >
                                        Date Created
                                        <span v-if="passed_key.key=='created_date' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'created_date'}" class="sorting-icon">
                                            <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                        </span>
                                        <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'created_date'}" class="sorting-icon">
                                            <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                        </span>
                                    </span>
                                </th>
                                <!-- <th class="whiteSpace w-1">
                                    <span v-on:click="setPasskey('product')" class="cursor-th" >
                                        Product
                                        <span v-if="passed_key.key=='product' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'product'}" class="sorting-icon">
                                            <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                        </span>
                                        <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'product'}" class="sorting-icon">
                                            <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                        </span>
                                    </span>
                                </th> -->
                                <th class="whiteSpace w-1">
                                    <span v-on:click="setPasskey('assigned_to')" class="cursor-th" >
                                        Assigned To
                                        <!-- <span v-if="passed_key.key=='assigned_to' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'assigned_to'}" class="sorting-icon">
                                            <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                        </span>
                                        <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'assigned_to'}" class="sorting-icon">
                                            <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                        </span> -->
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="ajaxCallInProgress" class="text-center font-weight-bold" style="background-color: #eff9fd !important;">
                                <td colspan="7">
                                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center"/>
                                </td>
                            </tr>
                            <tr v-if="!ajaxCallInProgress && allArchieveTickets.length == 0" class="text-center font-weight-bold ht-100px">
                                <td colspan="7">No Tickets Found</td>
                            </tr>
                            <tr v-else v-for="ticket in allArchieveTickets" :key="ticket.ticket_id">
                                <td class="whiteSpace w-1" @click="ticketDetails(ticket)">
                                    <span class="pointer text-secondary">{{"#" +ticket.ticket_number}}</span>
                                    <!-- <span class="pl-5" v-if="!ticket.is_parent_ticket">
                                        <el-tooltip class="item" effect="dark" content="Service Ticket" placement="top">
                                            <img style="width:13px !important" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/service_ticket.svg" :alt="ticket.ticket_number">
                                        </el-tooltip>
                                    </span> -->
                                </td>
                                <td class="whiteSpace w-1" @click="ticketDetails(ticket)">
                                    <button style="text-transform: capitalize;" class="btn btn-smm text-white btn-archieve">{{ticket.status}} hello</button>
                                </td>
                                <td class="whiteSpace w-1" @click="ticketDetails(ticket)">
                                    <div class="overflowing-text w-200px">
                                        {{ticket.created_by || '-'}}
                                    </div>
                                </td>
                                <td class="whiteSpace w-1 text-capitalize" @click="ticketDetails(ticket)">
                                    <div style="max-width:150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis">{{ticket.subject}}</div>
                                </td>
                                <td class="whiteSpace w-1" @click="ticketDetails(ticket)">
                                    {{ticket.created_date}}
                                </td>
                                <!-- <td class="whiteSpace w-1">
                                    {{ticket.products.toString() || '-'}}
                                </td> -->
                                <td class="whiteSpace w-1" :class="ticket.template_type == 'multi_part' ? '' : 'table-status'" @click="ticketDetails(ticket)">
                                    <div class="overflowing-text w-200px">
                                        {{ticket.assigned_to || '-'}}
                                    </div>
                                </td>
                                <td class="table-admin admin-actions" v-if="ticket.template_type != 'multi_part'">
                                    <el-popover placement="bottom-start" width="150" trigger="click">
                                        <div class="fw-500 p-2" @click="changeStatus(ticket)">Re-Open</div>
                                        <el-button slot="reference" style="border:none !important;background:transparent;">
                                            <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/more.svg" alt="">
                                        </el-button>
                                    </el-popover>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex align-items-center font-weight-bold mt-2 justify-content-end" v-if="total > 0">
                    <multiselect class="diginew-multiselect dd-ht multiple-select-arrow-hide"
                        :options="pageLimit" :close-on-select="true" v-model.number="limit"
                        @search-change="fetchListData"
                        open-direction="top" :show-labels="false" placeholder=""
                        style="width: 5.3em !important;padding-right: 10px!important;"></multiselect>
                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg"
                        style="margin-left: -35px;">
                    <span class="page-info pr-2 pl-6 fw-500"
                        style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;">Per page</span>
                    <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                        <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                            <i class="icon-chevron-double-left"></i>
                        </el-tooltip>
                    </button>
                    <button @click="previousPage()" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
                        <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                            <i class="icon icon-chevron-left"></i>
                        </el-tooltip>
                    </button>
                    <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                    <button @click="nextPage()" :disabled="skip_temp >= total" class="pagination-list mt-1 mr-2 pointer">
                        <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                            <i class="icon icon-chevron-right"></i>
                        </el-tooltip>
                    </button>
                    <button @click="lastPage()" class="mt-1 pointer pagination-list" :disabled ="temp_total == total">
                        <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                            <i class="icon-chevron-double-right"></i>
                        </el-tooltip>
                    </button>
                </div>
            </div>
        </div>
        <!-- <div v-if="display_filters" class="top_curve top_curve_archieve fadeInDown pb-3" :class="{'fadeInUp':hide_filters == true}"></div> -->
        <div v-if="display_filters" class="scm-filters overflow-visible">
            <filter-data @hideFilters="hideFilters" :showfilterData="showfilterData" @appliedFilter="appliedFilter"
            @showSuccessPopup="showSuccessPopup"
            @hideSuccessPopup="hideSuccessPopup"
            @showWarningPopup="showWarningPopup" @hideWarningPopup="hideWarningPopup"
            ></filter-data>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import {SweetModal} from 'sweet-modal-vue'
import { EventBus } from '../eventBus/nav-bar-event.js';
import archieve from '../mixins/archieve.js';
const FilterData = () => import('./FilterData')
export default {
    components:{
        SweetModal,
        Swal,
        FilterData
    },
    mixins:[archieve],
    data(){
        return{
            passed_key: {
                key: 'created_date',
                value: -1
            },
            display_filters: false,
            hide_filters: false,
            search_key:'',
            skip:0,
            limit:10,
            total:0,
            search_key:'',
            count:0,
            ajaxCallInProgress:false,
            allArchieveTickets:[],
            temp_total:0,
            skip_temp: 0,
            success_msg:'',
            warning_msg:'',
            selectedTicket:null,
            status:[],
            ticket_id:'',
            ticketStatus:'',
            showChange:false,
            closed_ticket:{},
            showfilterData:{
                created_templates: [],
                approvers: [],
                created_tags: [],
                assigned_to:[],
                branch:[],
                company_name:[],
                created_date:[],
                department:[],
                last_modified_date:[],
                priority:[],
                product:[],
                status:[],
                ticket_number:[],
                template:[],
                behalf_selected:[],
                behalf_of_whom:'customer',
                assign_to_whom:'person',
                ticket_type:''
            },
            filterData:{
                created_templates: [],
                created_tags: [],
                approvers: [],
                assigned_to:[],
                branch:[],
                company_name:[],
                created_date:[],
                department:[],
                last_modified_date:[],
                priority:[],
                product:[],
                status:[],
                ticket_number:[],
                template:[],
                behalf_selected:[],
                behalf_of_whom:'customer',
                assign_to_whom:'person',
                ticket_type:''
            },
            pageLimit: [],
        }
    },
    methods:{
        appliedFilter(data){
            this.filterData = {
                created_templates: data.value.created_templates,
                approvers: data.value.approvers,
                created_tags: data.value.created_tags,
                assigned_to:data.value.assigned_to,
                branch:data.value.branch,
                company_name:data.value.company_name,
                created_date:data.value.created_date,
                department:data.value.department,
                last_modified_date:data.value.last_modified_date,
                priority:data.value.priority,
                product:data.value.product,
                status:data.value.status,
                ticket_number:data.value.ticket_number,
                template:data.value.template,
                assign_to_whom:data.value.assign_to_whom,
                behalf_of_whom:data.value.behalf_of_whom,
                behalf_selected:data.value.behalf_selected,
                ticket_type:data.value.ticket_type
            }
            this.showfilterData = {
                created_templates: data.value1.created_templates,
                created_tags: data.value1.created_tags,
                approvers: data.value1.approvers,
                assigned_to:data.value1.assigned_to,
                branch:data.value1.branch,
                company_name:data.value1.company_name,
                created_date:data.value1.created_date,
                department:data.value1.department,
                last_modified_date:data.value1.last_modified_date,
                priority:data.value1.priority,
                product:data.value1.product,
                status:data.value1.status,
                ticket_number:data.value1.ticket_number,
                template:data.value1.template,
                assign_to_whom:data.value1.assign_to_whom,
                behalf_of_whom:data.value1.behalf_of_whom,
                behalf_selected:data.value1.behalf_selected,
                ticket_type:data.value.ticket_type
            }
            this.getTableData()
        },
        changeStatus(ticket){
            Swal.fire({
                title: 'Alert',
                text: "Are you sure want to reopen" + ' ' + JSON.stringify(ticket.ticket_number) + "?",
                type: 'warning',
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText:'YES',
                cancelButtonText:'NO'
            }).then((result) => {
                if (result.value) {
                    let params = {
                        ticket_id:ticket.ticket_id
                    }
                    this.confirmReopen(params)
                }
            })
        },
        async confirmReopen(params){
            try {
                let res = await this.reopenTicket(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.getTableData()
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        showFilters(){

            if(this.display_filters){
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else{
                this.display_filters = true
            }
        },
        hideFilters(){
            this.hide_filters = true
            this.display_filters = false
            setTimeout(() => {
                this.hide_filters = false
            }, 500);
        },
        setPasskey: async function (newKey) {
            this.$set(this.passed_key, 'key', newKey)
            var value = this.passed_key.value == -1 ? 1 : -1
            this.$set(this.passed_key, 'value', value)
            this.getTableData();
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.skip_temp = 0
            this.allArchieveTickets = []
            this.getTableData()
        },
        lastPage(){
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.getTableData();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            this.temp_total = this.skip_temp
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.getTableData();
        },
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getTableData();
        },
        async getTableData(){
            try {
                this.ajaxCallInProgress = true
                this.allArchieveTickets = []
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key.trim(),
                    sort_key: this.passed_key.key,
                    is_mobile:false,
                    filters:{
                        sort_value: this.passed_key.value,
                        assigned_to:{
                            select_all:false,
                            to:this.filterData.assign_to_whom,
                            value:this.filterData.assigned_to
                        },
                        branch:{
                            value:this.filterData.branch
                        },
                        company_name:{
                            value:this.filterData.company_name
                        },
                        date_range:{
                            created_date:this.filterData.created_date,
                            modification_date:this.filterData.last_modified_date,
                        },
                        department:{
                            value:this.filterData.department
                        },
                        priority:{
                            value:this.filterData.priority
                        },
                        product:{
                            select_all:false,
                            value:this.filterData.product
                        },
                        // template:{
                        //     value:this.filterData.template
                        // },
                        ticket_number:{
                            select_all:false,
                            value:this.filterData.ticket_number
                        },
                        on_behalf_of:{
                            for:this.filterData.behalf_of_whom,
                            select_all:false,
                            value:this.filterData.behalf_selected
                        },
                        tag :{
                            select_all: false,
                            value: this.filterData.created_tags,
                        },
                        approvers: {
                            select_all: false,
                            value: this.filterData.approvers
                        },
                        ticket_type:this.filterData.ticket_type,
                        template: {
                            select_all: false,
                            value: this.filterData.created_templates,
                        }
                    }
                }
                if(params.filters.assigned_to.value.length){
                  params.filters.assigned_to.select_all = false
                }else{
                    params.filters.assigned_to.select_all = true
                }
                if(params.filters.on_behalf_of.value.length){
                   params.filters.on_behalf_of.select_all = false
                }else{
                    params.filters.on_behalf_of.select_all = true
                }
                if(params.filters.product.value.length){
                    params.filters.product.select_all = false
                }else{
                    params.filters.product.select_all = true
                }
                if(params.filters.tag.value.length){
                    params.filters.tag.select_all = false
                }else{
                    params.filters.tag.select_all = true
                }
                if(params.filters.ticket_number.value.length){
                    params.filters.ticket_number.select_all = false
                }else{
                    params.filters.ticket_number.select_all = true
                }
                if(params.filters.template.value.length){
                    params.filters.template.select_all = false
                }else{
                    params.filters.template.select_all = true
                }
                if(params.filters.approvers.value.length){
                    params.filters.approvers.select_all = false
                }else{
                    params.filters.approvers.select_all = true
                }
                let res = await this.getAllArchieveTickets(params)
                this.allArchieveTickets = res.response.archive_tickets
                this.total = res.response.total_no_of_tickets
                this.ajaxCallInProgress = false
            } catch (reason) {

            }
        },
        ticketDetails(ticket){
            let newData = {
                filterData: this.filterData,
                showfilterData: this.showfilterData
            }
            localStorage.setItem("StoreFilterData", JSON.stringify(newData))
            EventBus.$emit('tabactivateArchieve',ticket)
        }
    },
    computed:{
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
    },
    watch: {
        limit: function(){
            this.getTableData();
        }
    },
    async mounted(){
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        if(localStorage.getItem('StoreFilterData')){
            let FilterData = JSON.parse(localStorage.getItem('StoreFilterData'));
            this.showfilterData = FilterData.showfilterData;
            this.filterData = FilterData.filterData;
        }
        this.getTableData()
        EventBus.$on('ReopenedSuccessUpdate',()=>{
            this.getTableData()
        })
    }
}
</script>
<style scoped>
.btn-archieve{
    background: #002262 !important;
}
.table-new-template tbody tr td{
    width: 10% !important;
}
.scm-filters {
    font-family: "Poppins", "Helvetica Neue", sans-serif !important;
    height: 490px;
    overflow: auto;
    max-width: 768px;
    top: 60px;
    background: #e6ecff !important;
}
.overflow-visible{
    overflow: scroll !important
}
.ht-100px{
    height: 100px;
}
.w-200px{
    width: 200px !important
}
</style>